import { EnquiryForm } from "./EnquiryForm";
import { FORMS } from "./formConfig";

export default function PartnerForm() {
  return <EnquiryForm config={FORMS.partner} />;
}
